import React from 'react';
import './DropdownMenu.css';

const DropdownMenu = ({
    title,
    hasSelectedItems,
    onClear,
    onApply,
    children
}) => {
    return (
        <div className="dropdown-menu">
            <div className="dropdown-header">
                <span>{title}</span>
                {hasSelectedItems && (
                    <button
                        className="clear-filters"
                        onClick={onClear}
                    >
                        Effacer
                    </button>
                )}
            </div>

            <div className="dropdown-content">
                {children}
            </div>

            <div className="dropdown-footer">
                <button
                    className="apply-filters"
                    onClick={onApply}
                >
                    Appliquer
                </button>
            </div>
        </div>
    );
};

export default DropdownMenu;